import request from 'request'

const asyncRequest = async ({ url, form }) =>
  new Promise((resolve) => {
    request.post(
      {
        url,
        form,
        json: true,
      },
      (error, response, data) => {
        resolve({ error, response, data })
      },
    )
  })

/**
 * Submit data to our data storage backend
 */
const storeData = async function ({ dataJson }) {
  const { error, response } = await asyncRequest({
    url: 'https://udm-analytics-api.steer-apps.com/save/',
    form: {
      json: JSON.stringify(dataJson),
    },
  })
  return { error, response }
}

export default {
  storeData,
}
